const css = `.create-ticket-card {
  box-shadow: var(--shadow-4);
  border-radius: 12px;
  overflow: hidden;
  width: 100%;
}
.create-ticket-card .card-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.create-ticket-card .card-header .card-icon {
  font-size: var(--font-size-xl);
  color: var(--text);
  margin-right: 16px;
}
.create-ticket-card .subtitle {
  font-size: var(--font-size-base);
  color: var(--text-muted);
  margin-top: 16px;
  margin-bottom: 16px;
  line-height: var(--line-height-normal);
}
.create-ticket-card form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.create-ticket-card form .form-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 24px;
}
.create-ticket-card form .dropdown-item-with-icon {
  display: flex;
  align-items: center;
  gap: 8px;
}
.create-ticket-card form .dropdown-item-with-icon i {
  font-size: var(--font-size-sm);
  flex-shrink: 0;
}
.create-ticket-card form .dropdown-item-with-icon span {
  flex: 1;
}
.create-ticket-card form .file-upload-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.create-ticket-card form .file-upload-section .files-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
}
.create-ticket-card form .file-upload-section .files-list .file-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 12px;
  background-color: var(--surface-50);
  border-radius: 8px;
}
.create-ticket-card form .file-upload-section .files-list .file-item .file-name {
  flex: 1;
  font-size: var(--font-size-sm);
  color: var(--text);
}
.create-ticket-card form .file-upload-section .files-list .file-item .file-size {
  font-size: var(--font-size-xs);
  color: var(--text-muted);
}
.create-ticket-card form .file-upload-section .helper-text {
  font-size: var(--font-size-xs);
  color: var(--text-muted);
}
.create-ticket-card form .form-actions {
  display: flex;
  gap: 12px;
  align-items: center;
}
.create-ticket-card form .form-actions .create-ticket-button {
  flex: 0 0 auto;
}
.create-ticket-card form .form-actions .cancel-button {
  flex: 0 0 auto;
}
@media (max-width: 768px) {
  .create-ticket-card form .form-row {
    grid-template-columns: 1fr;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
